module.exports = __webpack_public_path__ + "img/1-lg.6b511420.jpg";